//import ApiService from "@/core/services/api.service";

// mutation types
export const SET_ERROR = "setError";

const state = {
  users: [],
  asistencias: [],
  loading: false
};

const getters = {};

const actions = {
  getUsers() {
    /* return new Promise((resolve) => {
      context.commit("changeLoading", true);

      ApiService.get("usuario")
        .then(({ data }) => {
          
          context.commit("storeUsers", data.usuario);

          
          let url = ''
          const hostname = window.location.hostname
          if(hostname.includes("localhost") || hostname.includes("127.0.0.1")){
            url = 'https://res.appagricactus.com/uploads/'
          }else{
            url = 'https://res.appagricactus.com//uploads/'
          }
          data.usuario.map(function(x) {
            if (x.foto) {
              var myImage = new Image(100, 200);
              myImage.src = url + x.foto;
            }
          });
          context.commit("changeLoading", false)
          resolve(data);
        })
    });*/
  }
};

const mutations = {
  storeUsers(state, users) {
    state.users = users;
  },
  changeLoading(state, load) {
    state.loading = load;
  },
  [SET_ERROR](state, error) {
    state.errors = error;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
